import { render } from "./SectionCardComponent.vue?vue&type=template&id=4205ee74&scoped=true"
import script from "./SectionCardComponent.vue?vue&type=script&lang=js"
export * from "./SectionCardComponent.vue?vue&type=script&lang=js"

import "./SectionCardComponent.vue?vue&type=style&index=0&id=4205ee74&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4205ee74"]])

export default __exports__